import actions from "./actions";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  // States for handling login and student personal details creation
  isFetching: false,
  successMessage: "",
  errorMessage: "",
  actionType: "",
  status_code: 0,
  studentDetails: {}, // Add studentDetails to store the fetched data
});

export default function studentReducer(state = initialState, action) {
  switch (action.type) {
    // Student Personal Details Creation Actions
    case actions.STUDENT_PERSONAL_DETAILS_CREATE_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
        actionType: actions.STUDENT_PERSONAL_DETAILS_CREATE_REQUEST,
      });
    case actions.STUDENT_PERSONAL_DETAILS_CREATE_SUCCESS:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: actions.STUDENT_PERSONAL_DETAILS_CREATE_SUCCESS,
        successMessage: action.message,
        status_code: action.status_code,
      });
    case actions.STUDENT_PERSONAL_DETAILS_CREATE_ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: actions.STUDENT_PERSONAL_DETAILS_CREATE_ERROR,
        errorMessage: action.message,
        status_code: action.status_code,
      });

    // Student Personal Details Update Actions
    case actions.STUDENT_DETAILS_UPDATE_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
        actionType: actions.STUDENT_DETAILS_UPDATE_REQUEST,
      });
    case actions.STUDENT_DETAILS_UPDATE_SUCCESS:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: actions.STUDENT_DETAILS_UPDATE_SUCCESS,
        successMessage: action.message,
        status_code: action.status_code,
      });
    case actions.STUDENT_DETAILS_UPDATE_ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: actions.STUDENT_DETAILS_UPDATE_ERROR,
        errorMessage: action.message,
        status_code: action.status_code,
      });

    // Student Personal Details GET Actions
    case actions.STUDENT_PERSONAL_DETAILS_GET_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
        actionType: actions.STUDENT_PERSONAL_DETAILS_GET_REQUEST,
      });
    case actions.STUDENT_PERSONAL_DETAILS_GET_SUCCESS:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: actions.STUDENT_PERSONAL_DETAILS_GET_SUCCESS,
        studentDetails: action.data, // Store fetched student details
        successMessage: action.message,
        status_code: action.status_code,
      });
    case actions.STUDENT_PERSONAL_DETAILS_GET_ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: actions.STUDENT_PERSONAL_DETAILS_GET_ERROR,
        errorMessage: action.message,
        status_code: action.status_code,
      });

    case actions.ENROLLED_EXAMS_CREATE_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
        actionType: actions.ENROLLED_EXAMS_CREATE_REQUEST,
      });
    case actions.ENROLLED_EXAMS_CREATE_SUCCESS:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: actions.ENROLLED_EXAMS_CREATE_SUCCESS,
        successMessage: action.message,
        status_code: action.status_code,
      });
    case actions.ENROLLED_EXAMS_CREATE_ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: actions.ENROLLED_EXAMS_CREATE_ERROR,
        errorMessage: action.message,
        status_code: action.status_code,
      });

    // Reset Action
    case actions.RESET_ACTIONTYPE:
      return Immutable.merge(state, {
        actionType: "",
        successMessage: "",
        errorMessage: "",
        isFetching: false,
        status_code: 0,
        studentDetails: null, // Reset studentDetails when action is reset
      });

    default:
      return state;
  }
}
